import { apiProvider } from './api';
import { NAME } from './constants';
import { router } from './router';

export const DanVerification = {
	name: NAME,
	apiProvider,
	router,
};
